<template>
    <div id="global-dialogs">
        <Globalinvitetip 
        v-if="dialogname==='Globalinvitetip'"
        @globalDialogClose="globalDialogClose"></Globalinvitetip>
    </div>
</template>


<script>
    import Globalinvitetip from '@/components/globalDialog/Globalinvitetip.vue'
    export default {
        components:{
            Globalinvitetip
        },
        data(){
            return {
                dialogname:'',
                a:'b'
            }
        },
        methods:{
            globalDialogClose(){//全局组件销毁方法
                this.$destroy(true)  //销毁组件
                this.$el.parentNode.removeChild(this.$el)  //父元素中移除dom元素（$el为组件实例）
            }
        }
    }
</script>

<style lang="scss" scoped>
    #global-dialogs{

    }
</style>


// WEBPACK FOOTER //
// src/components/globalDialog/index.vue